import Tesseract from 'tesseract.js';

const stopwords = [
  // 전치사
  'in', 'on', 'at', 'by', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'over', 'under', 'again', 'further', 'then', 'once', 'of','for','as',
  // be동사
  'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being',
  // 정관사
  'the', 'a', 'an',
  // 대명사
  'i', 'you', 'he', 'she', 'it', 'we', 'they', 'me', 'him', 'her', 'us', 'them', 'my', 'your', 'his', 'its', 'our', 'their', 'mine', 'yours', 'hers', 'ours', 'theirs'
];

// OCR을 사용하여 이미지에서 텍스트 추출
export const extractTextFromImage = async (file) => {
  try {
    const { data: { text } } = await Tesseract.recognize(file, 'eng+kor', {
      logger: m => console.log(m)
    });
    return text;
  } catch (error) {
    console.error('OCR Error:', error);
    throw new Error('이미지에서 텍스트를 추출할 수 없습니다.');
  }
};

// 텍스트에서 단어 추출 및 정리 (불용어, 숫자 제외)
export const extractWordsFromText = async (text) => {
  if (!text || typeof text !== 'string') {
    return [];
  }

  // 텍스트 정리 및 단어 추출
  const cleanText = text
    .replace(/[^\w\s가-힣]/g, ' ') // 특수문자 제거
    .replace(/\s+/g, ' ') // 여러 공백을 하나로
    .trim();

  // 단어 분리 (영어와 한국어 모두 지원)
  const words = cleanText
    .split(/\s+/)
    .filter(word =>
      word.length > 1 &&
      // 숫자만으로 이루어진 단어 제외
      !/^\d+$/.test(word) &&
      // 영어 불용어 제외 (한글은 그대로 허용)
      (!/^[a-zA-Z]+$/.test(word) || !stopwords.includes(word.toLowerCase()))
    )
    .map((word, index) => ({
      id: `word-${Date.now()}-${index}`,
      text: word,
      frequency: 1,
      clicked: false,
      clickedAt: null
    }));

  // 중복 제거 및 빈도 계산
  const wordMap = new Map();
  words.forEach(word => {
    const key = word.text.toLowerCase();
    if (wordMap.has(key)) {
      wordMap.get(key).frequency += 1;
    } else {
      wordMap.set(key, { ...word, text: word.text });
    }
  });

  // 빈도순으로 정렬
  const uniqueWords = Array.from(wordMap.values())
    .sort((a, b) => b.frequency - a.frequency)
    .slice(0, 50); // 최대 50개 단어만 반환

  return uniqueWords;
};

export const detectLanguage = (text) => {
  const koreanRegex = /[가-힣]/;
  const englishRegex = /[a-zA-Z]/;
  const japaneseRegex = /[ひらがなカタカナ]/;

  if (koreanRegex.test(text)) return 'ko';
  if (japaneseRegex.test(text)) return 'ja';
  if (englishRegex.test(text)) return 'en';
  return 'en'; // 기본값
};

export const normalizeWord = (word, language = 'en') => {
  if (language === 'en') {
    // 영어 단어 정규화
    return word.toLowerCase()
      .replace(/s$/, '') // 복수형 s 제거
      .replace(/ing$/, '') // 현재진행형 ing 제거
      .replace(/ed$/, '') // 과거형 ed 제거
      .replace(/er$/, '') // 비교급 er 제거
      .replace(/est$/, '') // 최상급 est 제거
      .replace(/ly$/, ''); // 부사 ly 제거
  }
  return word;
};
